import { render, staticRenderFns } from "./ItinerarySectionItemOpeningHourSeasons.vue?vue&type=template&id=b147f428&scoped=true&"
import script from "./ItinerarySectionItemOpeningHourSeasons.vue?vue&type=script&lang=js&"
export * from "./ItinerarySectionItemOpeningHourSeasons.vue?vue&type=script&lang=js&"
import style0 from "./ItinerarySectionItemOpeningHourSeasons.vue?vue&type=style&index=0&id=b147f428&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b147f428",
  null
  
)

export default component.exports